module.exports = __webpack_public_path__ + "static/Lyra Health-13eb1109e375ee4ba51a669c4f1dc30d.jpg";